import { useSiteSettings } from "@/hooks/useSiteSettings";

interface PriceDisplayProps {
  showOriginal?: boolean;
  className?: string;
}

const PriceDisplay = ({ showOriginal = true, className }: PriceDisplayProps) => {
  const { data: settings, isLoading } = useSiteSettings();

  if (isLoading) {
    return (
      <div className={className}>
        <span className="text-primary text-3xl font-bold animate-pulse">...</span>
      </div>
    );
  }

  return (
    <div className={className}>
      {showOriginal && (
        <span className="text-muted-foreground line-through text-xl mr-2">
          {settings?.original_price || "$124.00"}
        </span>
      )}
      <span className="text-primary text-3xl font-bold">
        {settings?.sale_price || "$14.00"}
      </span>
    </div>
  );
};

export default PriceDisplay;
